const warn = (s: any) => {
  // TODO: handle logging of warnings
  // eslint-disable-next-line no-console
  console.warn('[react-gtm]', s);
};

export default warn;
